import { QueryClient } from '@tanstack/react-query';

const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: false,
      refetchOnWindowFocus: false,
      retry: false,
      gcTime: Number(process.env.REACT_APP_API_CACHE_TIME),
    },
  },
});

export default queryClient;
